import { render, staticRenderFns } from "./DynamicScroller.vue?vue&type=template&id=08149be8"
import script from "./DynamicScroller.vue?vue&type=script&lang=js"
export * from "./DynamicScroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports